import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import CHECKOUT_ACTIONS from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action';
import BAG_PAGE_ACTIONS from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import {
  clearAddToBagErrorState,
  clearAddToPickupErrorState,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import GlobalErrorComponent from '../views/GlobalErrorComponent.view';
import { hideError } from './GlobalErrorComponent.actions';
import {
  getErrorMessage,
  getErrorModalVisibleState,
  getErrorVisibleState,
} from './GlobalErrorComponent.selectors';
import withDynamicReducer from '../../../hoc/withDynamicReducer';
import GlobalErrorComponentReducer from './GlobalErrorComponent.reducer';
import {
  getIsRedesignGlobalHeaderEnabled,
  getNewGlobalErrorMessage,
  getNewGlobalErrorMessageDuration,
} from '../../../../../reduxStore/selectors/session.selectors';
import { resetErrorState } from '../../../../features/account/AddEditCreditCard/container/AddEditCreditCard.actions';

const shouldRenderComponent = ({
  newGlobalErrorMessageEnabled,
  fromModal,
  isErrorModalVisibleState,
  isVisible,
  fromCartAndCheckoutPageError,
}) =>
  newGlobalErrorMessageEnabled &&
  (fromCartAndCheckoutPageError ||
    ((!fromModal || isErrorModalVisibleState) && (isVisible || fromModal)));

const GlobalErrorComponentContainer = (props) => {
  const {
    isVisible,
    fromModal,
    isErrorModalVisibleState,
    fromCartAndCheckoutPageError,
    newGlobalErrorMessageEnabled,
    ...otherProps
  } = props;
  if (
    !shouldRenderComponent({
      newGlobalErrorMessageEnabled,
      fromModal,
      isErrorModalVisibleState,
      isVisible,
      fromCartAndCheckoutPageError,
    })
  ) {
    return null;
  }

  return (
    <GlobalErrorComponent
      isVisible={isVisible}
      fromModal={fromModal}
      fromCartAndCheckoutPageError={fromCartAndCheckoutPageError}
      {...otherProps}
    />
  );
};

export const mapStateToProps = (state) => {
  return {
    isVisible: getErrorVisibleState(state),
    errorMessage: getErrorMessage(state),
    newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
    isErrorModalVisibleState: getErrorModalVisibleState(state),
    errorMessageDuration: getNewGlobalErrorMessageDuration(state),
    isGlobalHeaderRedesignEnabled: getIsRedesignGlobalHeaderEnabled(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    hideErrorAction: (payload) => {
      dispatch(hideError(payload));
    },
    clearCheckoutServerError: (data) => dispatch(CHECKOUT_ACTIONS.setServerErrorCheckout({ data })),
    clearCheckoutClientError: (data) => dispatch(CHECKOUT_ACTIONS.setCheckoutClientError(data)),
    clearCartItemsSflError: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setCartItemsSflError(payload));
    },
    clearAddToBagError: () => {
      dispatch(clearAddToBagErrorState());
    },
    clearPickUpError: () => {
      dispatch(clearAddToPickupErrorState());
    },
    resetAddCardError: () => {
      dispatch(resetErrorState());
    },
    setMaxItemErrorAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setMaxItemError(payload));
    },
    setOOSErrorAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setOOSError(payload));
    },
    setBackPackDeletedErrorAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setBackPackDeletedError(payload));
    },
  };
};

const withReducer = withDynamicReducer({
  key: 'GlobalErrorComponent',
  reducer: GlobalErrorComponentReducer,
});
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withConnect)(GlobalErrorComponentContainer);
